module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"orderDate":"Data ordine","deliverOrder":"Consegna ritocchi","confirmDeliverOrderTitle":"Consegna ritocchi","confirmDeliverOrderText":"Sei sicuro di voler consegnare l\u0027ordine?","orderSent":"Ordine inviato al cliente"}}')
  delete Component.options._Ctor
}
